import {
    async
} from 'regenerator-runtime';
import {
    API_URL, KEY
} from './config.js';
import {
    RES_PER_PAGE
} from './config.js';
import {
    AJAX
} from './helpers.js';
import recipeView from './views/recipeView.js';

export const state = {
    recipe: {},
    search: {
        query: '',
        results: [],
        page: 1,
        resultsPerPage: RES_PER_PAGE
    },
    bookmarks: []
};

const createRecipeObject = function(data) {
    const { recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        // We do that because not all the recipies will have a key, so we use short-circuiting for validating that
        // If we do not have a key, it will be false and nothing will happen and if there is a value,
        // then we're going to assign the value to the property. CHECK WHY WE USE SPREAD OP
        ...(recipe.key && {key: recipe.key})
    };
};


export const loadRecipe = async function (id) {
    try {
        recipeView.renderSpinner();
        const data = await AJAX(`${API_URL}${id}?key=${KEY}`);
        state.recipe = createRecipeObject(data);

        // some() will return true if any of the array items matches with a condition
        // We do that because as we're loading the recipe information from the API, when we bookmarked
        // a recipy, then when bookmarked another and we went to the last one, we lost the information
        // about if it was bookmarked because it is loaded from scratch from the API. With this we compare
        // the recipe ID provided by the API, and if it's inside the bookmarks array, then we update the
        // property 'bookmarked' to true
        if (state.bookmarks.some(bookmark => bookmark.id === id))
            state.recipe.bookmarked = true
        else state.recipe.bookmarked = false
        console.log('Res: ', state.recipe);

    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query;
        // This will load all recipies including the ones which contains our own KEY
        const data = await AJAX(`${API_URL}?search=${query}&key=${KEY}`);

        state.search.results = data.data.recipes.map(rec => {
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...(rec.key && {key: rec.key})
            }
        });
        state.search.page = 1;

    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const getSearchResultsPage = function (page = state.search.page) {
    // When we pass the page in the parameter, we will store that value in the state data tree
    state.search.page = page;
    // EX: page: 1, 1-1 = 0; 0 * 10 = 0
    // EX: page: 2, 2 - 1 = 1; 1 * 10 = 10 (Starting at index 10)
    const start = (page - 1) * 10;
    // EX: page: 1, 1 * 10 = 10 (Ending index 10)
    // EX: page: 2, 2 * 10 = 20 (Ending index 20)
    const end = page * RES_PER_PAGE;

    return state.search.results.slice(start, end);
}


export const updateServings = function (newServings) {
    // Here we iterate all the ingredients and for each one, we modify the property 'quantity' so it is
    // updated according to the servings
    state.recipe.ingredients.forEach(ing => {
        // state.recipe.servings contains 
        ing.quantity = ing.quantity * newServings / state.recipe.servings;
        // newQt = oldQt * newServings / oldServings ==> 2 * 8 / 4 = 4
    });

    // Update state
    // Of course we update the state at the end because otherwise we would not be able to
    // have the old servings data needed for the calculation
    state.recipe.servings = newServings;
};

export const persistBookmarks = function () {
    localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
}



export const addBookmark = function () {
    // Add new bookmark
    state.bookmarks.push(state.recipe);

    // Mark current recipe as bookmarked 
    state.recipe.bookmarked = true;
    persistBookmarks();
};

export const deleteBookmark = function () {
    const index = state.bookmarks.findIndex(el => el.id === state.recipe.id);
    state.bookmarks.splice(index, 1);
    // Mark current recipe as not bookmarked
    state.recipe.bookmarked = false;
    persistBookmarks();
};

const init = function () {
    const storage = localStorage.getItem('bookmarks');
    if (storage) state.bookmarks = JSON.parse(storage);
}

init();


// Dev function
const clearBookmarks = function () {
    localStorage.clear('bookmarks');
}

// clearBookmarks();
var ingArr = [];
export const uploadRecipe = async function (newRecipe) {
    try {
        let nData = 0;
        let auxArr = [];
        console.log('newRecipe model: ', newRecipe);
        // Converting an object to an array
        const ingredients = Object.entries(newRecipe).filter(
            // entry[0] => key entry[1] => value
            entry => entry[0].startsWith('ingredient') && entry[1] !== ''
        )
        .forEach(ing => {
            nData++;
            auxArr.push(ing[1]);
            if(nData === 3) {
                const [quantity, unit, description] = auxArr;
                // Data validation
                if(!(quantity > 0 && unit !== '' && description !== '')) 
                throw new Error('Wrong ingredient format. Please, use the correct format.');

                auxArr = [];
                nData = 0;

                ingArr.push({
                    quantity: quantity ? +quantity : null,
                    unit,
                    description
                });
            }

            
            // Creating array of value part from array (the ingredients)
            // const ingArr = ing[1].split(',').map(el => el.trim());
            // console.log('ingArr:', ingArr);
            // Checking info
            // if (ingArr.length !== 3) throw new Error('Wrong ingredient format. Please, use the correct format.');
            // Getting info from the second element of each entry
            // const [quantity, unit, description] = ingArr;
           

            // return {
            //     quantity: quantity ? +quantity : null,
            //     unit,
            //     description
            // };
        });

        console.log('Ingredients: ', ingredients);
        console.log('Ing arr: ', ingArr);

        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingArr
        };
        console.log('Recipe: ', recipe);
        // Sending JSON
        const data = await AJAX(`${API_URL}?key=${KEY}`, recipe);
        state.recipe = createRecipeObject(data);

        // When we add a new recipy, it will automatically be marked as bookmarked.
        addBookmark(state.recipe);
      
    } catch (err) {
        throw err;
    }
}